import * as HotspotTargetType from "utils/HotspotTargetType";
import makeGetHotspotEntity from "selectors/hotspots/makeGetHotspotEntity";
import reduxStore from "utils/storeFactory";
import { notifyExternalOfHotspotClick } from "utils/externalMessaging";
import get from "lodash/get";

// Create a function to handle hotspot clicks. We don't use any bindings because they will break
// pure rendering.
export default function handleExternalCallbackHotspotClick(id) {
  const getHotspotEntity = makeGetHotspotEntity();
  const state = reduxStore.getState();
  const hotspotEntity = getHotspotEntity(state, { hotspotId: id });

  const hotspotTarget = hotspotEntity.target;

  if (hotspotTarget.type === HotspotTargetType.EXTERNAL_CALLBACK) {
    if (get(hotspotTarget, "pause", true)) {
      // Pause the player automatically
      window.VersePlayer.pause();
    }
    notifyExternalOfHotspotClick(
      hotspotEntity.target.identifier || "default identifier",
    );
  }
}
